import * as React from 'react';

import { Block, Row } from 'emotion-jsxstyle';
import { Button, Form, Input, InputGroup, Label } from 'reactstrap';

import { Link } from 'react-router-dom';
import Media from 'react-media';

export interface SearchProps {
  /** Placeholder for search input */
  placeholder: string;
  /** Initial search value */
  initialValue: string;
  /** Search form submission handler */
  onSubmit: (query: string) => void;
  /** Path for the clear all button to take the user to */
  pathToClearSearch?: string;
}

export interface SearchState {
  value: string;
}

export class Search extends React.Component<SearchProps, SearchState> {
  state: SearchState = { value: this.props.initialValue };

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.props.onSubmit(this.state.value);
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ value: e.target.value });
  };

  render() {
    return (
      <Form onSubmit={this.handleSubmit} style={{ width: '100%', flex: '1' }}>
        <Label for="search" hidden={true}>
          Search
        </Label>
        <Media query="(min-width: 1000px)">
          {(match: boolean) => (
            <Row alignItems="center" justifyContent="space-between">
              <Block flex="1">
                <InputGroup>
                  <Button type="submit">
                    <i className="fa fa-search" />
                    {match && <span> Search</span>}
                  </Button>
                  <Input
                    id="search"
                    autoFocus={match}
                    autoComplete="off"
                    onChange={this.handleChange}
                    placeholder={this.props.placeholder}
                    style={{ display: 'block', width: '100%', minWidth: 320 }}
                    type="search"
                    value={this.state.value}
                  />
                </InputGroup>
              </Block>
              {this.props.pathToClearSearch && (
                <Link className="d-block ml-3" to={this.props.pathToClearSearch}>
                  <small>Reset{match && <span> Filters</span>}</small>
                </Link>
              )}
            </Row>
          )}
        </Media>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Search.tsx